export default "__VITE_ASSET__Ci9TOj0c__"